import { DEFAULT_CONTENT_CONTEXT } from 'app/ContentContext/const';

import * as devices from './web-interface-devices';
import {
  COMPONENT_DESELECTED,
  COMPONENT_HOVER_ENTER,
  COMPONENT_HOVER_LEAVE,
  COMPONENT_SELECTED,
  DEVICE_SELECTED,
  EMPTY_COMPONENT_PAYLOAD,
  IS_MOBILE,
  SET_CONTENT_LINK_STATUS,
  SET_MWP_IFRAME_REF,
  UPDATED_CONTENT_CONTEXT,
  UPDATED_HIDDEN_EXPERIMENTS
} from './const';

export const defaultComponent = EMPTY_COMPONENT_PAYLOAD;

export const DEFAULT_STATE = {
  contentLinkDisabled: true,
  device: devices.RESPONSIVE_SIZE.value,
  isMobile: false,
  hiddenExperiments: {},
  preview: DEFAULT_CONTENT_CONTEXT,
  componentSelected: defaultComponent,
  componentHovering: defaultComponent,
  mwpiFrameRef: {}
};

const toggleListItem = ({ item, list = [] }) =>
  list.includes(item) ? list.filter(e => e !== item) : list.concat(item);

/**
 * Reducer for canvas
 * @param {object} state - state object for canvas
 * @param {object} action - dispatched action object
 * @returns {object} new state.object after dispatched performing action
 */
export const previewPaneReducer = function previewPaneReducer(
  state = DEFAULT_STATE,
  action = {}
) {
  switch (action.type) {
    case COMPONENT_DESELECTED: {
      return {
        ...state,
        componentSelected: defaultComponent,
        componentHovering: defaultComponent
      };
    }
    case COMPONENT_HOVER_ENTER: {
      return { ...state, componentHovering: action.component };
    }
    case COMPONENT_HOVER_LEAVE: {
      return { ...state, componentHovering: defaultComponent };
    }
    case COMPONENT_SELECTED: {
      return {
        ...state,
        componentSelected: action.component,
        componentHovering: defaultComponent
      };
    }
    case DEVICE_SELECTED: {
      const device =
        devices.DESKTOP_DEVICES[action.device] || devices.MOBILE_DEVICES[action.device];
      if (device) {
        return { ...state, device: action.device };
      }
      return { ...state, device: devices.RESPONSIVE_SIZE.value };
    }
    case IS_MOBILE:
      return { ...state, isMobile: action.isMobile };
    case SET_CONTENT_LINK_STATUS: {
      return { ...state, contentLinkDisabled: action.status };
    }
    case SET_MWP_IFRAME_REF: {
      return { ...state, mwpiFrameRef: action.ref };
    }
    case UPDATED_CONTENT_CONTEXT: {
      const { key, value: item } = action.payload;
      const { [key]: list } = state.preview;
      return {
        ...state,
        preview: {
          ...state.preview,
          [key]: toggleListItem({ item, list })
        }
      };
    }
    case UPDATED_HIDDEN_EXPERIMENTS: {
      const { name, variant: item } = action.payload;
      const { [name]: list } = state.hiddenExperiments;
      return {
        ...state,
        hiddenExperiments: {
          ...state.hiddenExperiments,
          [name]: toggleListItem({ item, list })
        }
      };
    }
    default:
      return state;
  }
};
